import { createFileRoute } from "@tanstack/react-router";
import TmsOverviewPage from "@/pages/TmsOverviewPage";
export const Route = createFileRoute("/lp-tms-therapy-coral-springs-florida")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Therapy Overview | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Transcranial Magnetic Stimulation (TMS) therapy in Coral Springs, FL. Non-invasive, FDA-cleared treatment for depression, anxiety, OCD & PTSD. Covered by.",
        },
        {
          property: "og:title",
          content: "TMS Therapy Overview | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Transcranial Magnetic Stimulation (TMS) therapy in Coral Springs, FL. Non-invasive, FDA-cleared treatment for depression, anxiety, OCD & PTSD. Covered by.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsOverviewPage />;
}
